import { Link } from 'react-router-dom'
import { INGREDIENT_TYPES_MAP } from '../../Ingredients/domain/info'
import { formatIngredientCatalogPrice } from './ingredientPriceUtils'

const ingredientViewPath = (ingredient: IDishIngredient): string => {
  const ingredientId =
    ingredient.ingredient_id ?? ingredient.ingredient?.id ?? 0
  return `/commercial/ingredients/view/${ingredientId}`
}

const ReceitTab = ({ dish }: { dish: IDishData }): JSX.Element => {
  if (!dish) {
    return <></>
  }

  const ingredients =
    dish.ingredients?.filter(ingredient => ingredient.ingredient) ?? []
  const compositions =
    dish.compositions?.filter(composition => composition.dishComposition) ?? []

  return (
    <div className="portlet light mt-5">
      <div className="portlet-body form">
        <h4>Ingredientes</h4>
        <table
          id="kt_datatable"
          className="dataTable table table-striped table-row-bordered gs-3 border table-hover"
        >
          <thead>
            <tr className="border-bottom border-end">
              <th>Nome </th>
              <th>Unidade de medida </th>
              <th> Medida </th>
              <th> Quantidade </th>
              <th> Preço </th>
              <th> Fator de cocção % </th>
              <th> Descrição </th>
            </tr>
          </thead>
          <tbody>
            {ingredients.map(ingredient => (
              <tr key={ingredient.id}>
                <td>
                  <Link to={ingredientViewPath(ingredient)}>
                    {ingredient.ingredient?.name}
                  </Link>
                </td>
                <td>
                  {
                    INGREDIENT_TYPES_MAP[
                      ingredient.ingredient?.unit_measure as INGREDIENT_TYPES
                    ]
                  }
                </td>
                <td>{ingredient.measure}</td>
                <td>{ingredient.quantity}</td>
                <td>{formatIngredientCatalogPrice(ingredient.ingredient)}</td>
                <td>{ingredient.factor_cooking ?? '-'}</td>
                <td>{ingredient.description}</td>
              </tr>
            ))}
            <tr></tr>
          </tbody>
        </table>
      </div>
      <div>
        <h4 className="mt-8">Modo de preparo</h4>
        <p style={{ whiteSpace: 'pre-line' }}>{dish.description}</p>
      </div>

      {compositions.length !== 0 && (
        <h3 className="mt-14 mb-6 bg-secondary p-4">Outros preparos:</h3>
      )}
      {compositions.map(composition => (
        <div key={composition.id} className="mb-14 mx-4">
          <h2>{composition.dishComposition.name}</h2>
          <h4>Ingredientes</h4>
          <table
            id="kt_datatable"
            className="dataTable table table-striped table-row-bordered gs-3 border table-hover"
          >
            <thead>
              <tr className="border-bottom border-end">
                <th>Nome </th>
                <th>Unidade de medida </th>
                <th> Medida </th>
                <th> Quantidade </th>
                <th> Preço </th>
                <th> Fator de cocção % </th>
                <th> Descrição </th>
              </tr>
            </thead>
            <tbody>
              {composition.dishComposition.ingredients
                ?.filter(ingredient => ingredient.ingredient)
                .map(ingredient => (
                  <tr key={ingredient.id}>
                    <td>
                      <Link to={ingredientViewPath(ingredient)}>
                        {ingredient.ingredient?.name}
                      </Link>
                    </td>
                    <td>
                      {
                        INGREDIENT_TYPES_MAP[
                          ingredient.ingredient
                            ?.unit_measure as INGREDIENT_TYPES
                        ]
                      }
                    </td>
                    <td>{ingredient.measure}</td>
                    <td>{ingredient.quantity}</td>
                    <td>
                      {formatIngredientCatalogPrice(ingredient.ingredient)}
                    </td>
                    <td>{ingredient.factor_cooking ?? '-'}</td>
                    <td>{ingredient.description}</td>
                  </tr>
                ))}
              <tr></tr>
            </tbody>
          </table>
          <div>
            <h4 className="mt-8">Modo de preparo</h4>
            <p style={{ whiteSpace: 'pre-line' }}>
              {composition.dishComposition.description}
            </p>
          </div>
          <hr className="mt-14" />
        </div>
      ))}
    </div>
  )
}

export default ReceitTab
